module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Ignac_Magda.44560c1f.jpg";